var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9525 15.9213C27.96 16.0975 27.965 16.2738 27.965 16.4525C27.965 21.8737 23.8375 28.1262 16.29 28.1262C13.9725 28.1262 11.8162 27.4475 10 26.2838C10.3212 26.3213 10.6475 26.34 10.9788 26.34C12.9012 26.34 14.67 25.685 16.075 24.5837C14.2787 24.5513 12.7638 23.365 12.2413 21.735C12.4925 21.7825 12.7488 21.8075 13.0138 21.8075C13.3875 21.8075 13.75 21.7575 14.095 21.6637C12.2175 21.2875 10.8037 19.6287 10.8037 17.6413V17.5888C11.3562 17.8962 11.99 18.0813 12.6625 18.1025C11.5612 17.3663 10.8362 16.11 10.8362 14.6875C10.8362 13.935 11.0388 13.23 11.3925 12.6237C13.4163 15.1062 16.44 16.74 19.85 16.9113C19.78 16.6112 19.7437 16.2975 19.7437 15.9762C19.7437 13.71 21.5812 11.8725 23.8462 11.8725C25.0275 11.8725 26.0938 12.3713 26.8412 13.1687C27.7762 12.985 28.655 12.6438 29.4475 12.1737C29.1413 13.1313 28.49 13.935 27.6437 14.4438C28.4737 14.3438 29.2638 14.1237 30 13.7975C29.45 14.62 28.7537 15.3425 27.9525 15.9213ZM20 0C8.95375 0 0 8.95375 0 20C0 31.045 8.95375 40 20 40C31.0462 40 40 31.045 40 20C40 8.95375 31.0462 0 20 0",
    fill: "#41A1F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.225aa16ec5efe253f294076a80ca0b49.svg";
export { ForwardRef as ReactComponent };